/**
 * Global Functionality
 * The logic in this is intended to ONLY contain any functionality
 * that is required on every page load.
 *
 * NOTE: Please do not include any page-specific logic here.
 **/

import ThemeMediaLightbox from '../partials/themeMediaLightbox';
import Logger from "../utilities/Logger";
import Elements from "../utilities/Elements";
import Evts from "../utilities/Evts";
import { gsap } from "gsap";

export default function () {
		const NAME = 'GLOBALS';
		Logger.log(`${NAME} > loading`);

		// Vars
		// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒
		const bdy                = document.body;
		const main               = document.getElementsByTagName('main')[0];
		const themeMediaLightboxDom = document.querySelector('[data-theme-media-lightbox]');
		const themeMediaLightbox    = themeMediaLightboxDom ? new ThemeMediaLightbox(themeMediaLightboxDom) : undefined;
		const global_nav         = {
				footer: Elements.id('global_footer'),
				supportsVib: navigator.vibrate || navigator.webkitVibrate || navigator.mozVibrate || navigator.msVibrate || null,
				mobileTablet_menu: Elements.id('mobile-tablet_menu'),
				mobileTablet_menu_tl: null,
				menuVisible_timeout: null,
				sister_cos_menu: Elements.id('sister-cos_menu'),
				current_page_in_header_label: Elements.id('current-page-in-header_label'),
		};

		// Logic
		// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒

		/**
		 * init --- Initialization block
		 */
		function init() {
				Logger.log(`${NAME} > init`);
				addHandlers();

				// Initialize the media lightbox
				themeMediaLightbox?.init();

				// Add aria current page (to be replaced in WP)
				const pages = ["home","projects","originals","studio","careers","contact"];
				if (~ pages.indexOf(bdy.id)) {
						const curr_page = pages[pages.indexOf(bdy.id)];
						for (const [index, val] of document.querySelectorAll('.global-nav-desktop__a').entries()) {
								// console.log(NAME + ` > init > ${index}, ${val}`,val);
								const valD = val.title.toLowerCase();
								if (valD.includes(curr_page) && valD.indexOf("Flight") === -1) {
										val.setAttribute('aria-current', "page");
										break;
								}
						}

						for (const [index, val] of document.querySelectorAll('.global-nav-mobile-tablet__a').entries()) {
								const valD = val.title.toLowerCase();
								if (valD.includes(curr_page) && valD.indexOf("Flight") === -1) {
										val.setAttribute('aria-current', "page");
										break;
								}
						}
				}

				[...document.querySelectorAll('.global-nav-desktop__a--lang')].forEach((el) => {
						el.classList.remove('global-nav-desktop__a--lang-trans-in');
				});

				Elements.id('sister-cos-desktop_menu').removeAttribute('style');
		}

		/**
		 * addHandlers --- Add event handlers for view
		 */
		function addHandlers() {
				Logger.log(`${NAME} > addHandlers`);
				Evts.addMultiple(Elements.id("global_nav"), ['mouseover', 'mousedown'], onGlobalNav);
				Evts.add(Elements.id("sister-cos-desktop_button"), 'mouseover', onDesktopSisterCoMenu, true);
				Evts.add(main, 'mouseover', onBdy);
		}

		/**
		 * onDesktopSisterCoMenu -- Open/close sister co menu
		 * @param evt
		 */
		function onDesktopSisterCoMenu(evt) {
				let target = evt.target;
				switch (evt.type) {
						case 'mouseover':
								Elements.id('sister-cos-desktop_menu').setAttribute('aria-expanded', 'true');
								break;
				}
		}

		/**
		 * onBdy --- This closes the Sister Co’s menu when a user rolls over the body element
		 */
		function onBdy() {
				Elements.id('sister-cos-desktop_menu').setAttribute('aria-expanded', 'false');
		}

		/**
		 * onGlobalNav -- Global nav
		 * @param evt
	 // */
		function onGlobalNav(evt) {
				let target = evt.target;
				// Logger.log("onGlobalNav >", Logger.console__style001, target, target.nodeName);

				if (evt.type === 'mouseover') document.getElementById('ReelFX_Fire_v2').querySelectorAll("animate").forEach(el => el.beginElement());

				if (!target) return;

				if (~["BUTTON", "A", "LABEL"].indexOf(target.nodeName) && evt.type === 'mousedown') {

						let classes = target.className.split(" ");
						if (classes) {
								// Search for class and react on match
								for (let x = 0; x < classes.length; x++) {

										switch (classes[x]) {
												case "global-nav-mobile-tablet__label":
														if (global_nav.supportsVib) navigator.vibrate(76);

														if (global_nav.mobileTablet_menu.getAttribute('aria-expanded') === 'false') {
																if (global_nav.menuVisible_timeout) clearTimeout(global_nav.menuVisible_timeout);
																global_nav.mobileTablet_menu.setAttribute('aria-expanded', 'true');
																document.getElementsByTagName("HTML")[0].classList.add('global-html--blacked-out');

																global_nav.footer.style.display = 'none';

																[...document.querySelectorAll('.global-nav-mobile-tablet__li')].forEach((el) => {
																		el.classList.add('global-nav-mobile-tablet__li--vis');
																});

																[...document.querySelectorAll('.global-nav-mobile-tablet__a--lang')].forEach((el) => {
																		el.classList.remove('global-nav-mobile-tablet__a--lang-trans-in');
																});

																document.getElementById('ReelFX_Fire_mobile_v2').querySelectorAll("animate").forEach(el => el.beginElement());

																global_nav.current_page_in_header_label.classList.add('global-nav-mobile-tablet__current-page--open-menu');

																// 	tl.reversed() ? tl.play() : tl.reverse()
																if (!global_nav.mobileTablet_menu_tl) {
																		global_nav.mobileTablet_menu_tl = gsap.timeline();
																		global_nav.mobileTablet_menu_tl.to("#mobile-tablet-ham_icon", {
																				duration: .3,
																				backgroundPosition: "-120px 0px",
																				ease: "steps(6)"
																		});
																} else {
																		global_nav.mobileTablet_menu_tl.play();
																}
														} else {
																global_nav.mobileTablet_menu_tl.reverse();

																if (global_nav.menuVisible_timeout) clearTimeout(global_nav.menuVisible_timeout);
																global_nav.menuVisible_timeout = setTimeout(() => global_nav.mobileTablet_menu.setAttribute('aria-expanded', 'false'), 444);
																document.getElementsByTagName("HTML")[0].classList.remove('global-html--blacked-out');
																global_nav.footer.style.display = 'block';

																[...document.querySelectorAll('.global-nav-mobile-tablet__li')].forEach((el) => {
																		el.classList.toggle('global-nav-mobile-tablet__li--vis');
																});

																[...document.querySelectorAll('.global-nav-mobile-tablet__a--lang')].forEach((el) => {
																		el.classList.add('global-nav-mobile-tablet__a--lang-trans-in');
																});
																document.getElementById('ReelFX_Fire_mobile_v2').querySelectorAll("animate").forEach(el => el.beginElement());
																global_nav.current_page_in_header_label.classList.remove('global-nav-mobile-tablet__current-page--open-menu');
														}

														break;
												case 'global-nav-mobile-tablet__a':
														Logger.log(evt.type);
														if (global_nav.supportsVib) navigator.vibrate([20, 76, 20]);

														if (target.id === 'sister-cos_button') {
																if (global_nav.sister_cos_menu.getAttribute('aria-expanded') === 'false') {
																		target.parentElement.style.maxHeight = '2000px';
																		if (global_nav.supportsVib) navigator.vibrate(110);
																		global_nav.sister_cos_menu.setAttribute('aria-expanded', 'true');
																		target.classList.add('open-menu');
																} else {
																		target.parentElement.style.maxHeight = '48px';
																		if (global_nav.supportsVib) navigator.vibrate(110);
																		global_nav.sister_cos_menu.setAttribute('aria-expanded', 'false');
																		target.classList.remove('open-menu');
																}
														}
														break;
												case 'global-nav-mobile-tablet__tm':
														if (global_nav.supportsVib) navigator.vibrate(76);
														break;
										}
								}
						}
				}
		}

		// Do not edit below this line...
		// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒
		Logger.log(`${NAME} > loaded`);
		init();
}
